import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text, Button } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';
import SmsCodeWhite from '../icons/SmsCodeWhite';

import styles from './styles';
const useStyles = createUseStyles(styles, 'Welcome');

const Welcome = ({ onClickStart }) => {
    const classes = useStyles();
    const { t } = useWeb5Context();

    return (
        <div className={classes.root}>
            <div className={classes.blueBox}>
                <SmsCodeWhite className={classes.blueBoxIcon} />
                <Text type="h6" className={classes.blueBoxText}>
                    {t('cfm_label_2fa_welcome')}
                </Text>
            </div>
            <Text bold className={classes.title}>
                {t('cfm_label_2fa_welcome_desc')}
            </Text>
            <Text className={classes.description}>{t('cfm_label_2fa_welcome_desc_2')}</Text>
            <div className={classes.buttonContainer}>
                <Button size="big" onClick={onClickStart}>
                    {t('cfm_action_2fa_welcome_start')}
                </Button>
            </div>
        </div>
    );
};

Welcome.propTypes = {
    onClickStart: PropTypes.func,
};

export default memo(Welcome);
